import axios from "axios";

import { fetchCookie } from "@utils/cookies";
import { validateCurrentToken, clearAuthData } from "@utils/tokenUtils";

const customFetch = axios.create({
  baseURL: process.env["REACT_APP_API_BASE_URL"],
});

customFetch.interceptors.request.use((config: any) => {
  if (!validateCurrentToken()) {
    return Promise.reject(new Error("Token expired"));
  }

  let _token = fetchCookie("1Q_SPA");
  if (_token) {
    config.headers.common["Authorization"] = `Bearer ${_token}`;
  }

  const source = axios.CancelToken.source();
  config.cancelToken = source.token;
  config.cancel = () => {
    source.cancel("Request canceled by user");
  };

  return config;
});

customFetch.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthData();
      window.location.href = "/sign-in/";
    }

    return Promise.reject(error);
  }
);

export default customFetch;
